// No.23 アンケート：回答（行）を Survey.vue の value 形式へ変換する共通ユーティリティ
// rows: [{survey_id, option_id, answer_no, answer_text}]
// → { [surveyId]: { answer_text, option_ids } }
export function buildAnswerMap(surveys, answerRows) {
  const map = {};
  (surveys || []).forEach((s) => {
    map[s.id] = { answer_text: '', option_ids: [] };
  });
  (answerRows || []).forEach((r) => {
    if (!map[r.survey_id]) {
      map[r.survey_id] = { answer_text: '', option_ids: [] };
    }
    if (r.answer_text !== null && r.answer_text !== undefined && r.answer_text !== '') {
      map[r.survey_id].answer_text = r.answer_text;
    }
    if (r.option_id !== null && r.option_id !== undefined) {
      map[r.survey_id].option_ids.push(r.option_id);
    }
  });
  return map;
}

export default { buildAnswerMap };
